import React, { Children, cloneElement, forwardRef } from "react";
import classNames from "classnames";
import useDarkMode from "../../Hooks/useDarkMode";

export const AvatarGroup = ({ className, children, size = 32 }) => {
  const { darkModeStatus } = useDarkMode();

  const randomColor = () => {
    const colors = [
      "primary",
      "secondary",
      "success",
      "info",
      "warning",
      "danger",
    ];

    const color = Math.floor(Math.random() * colors.length);

    return colors[color];
  };

  return (
    <div className={classNames("avatar-group", className)}>
      <div className="avatar-container">
        {Children.map(children, (child, index) =>
          index < 3
            ? cloneElement(child, {
                borderColor: darkModeStatus ? "dark" : "white",
                border: 2,
                color: child.props.color || randomColor(),
                size,
              })
            : null
        )}
      </div>
    </div>
  );
};

const Avatar = forwardRef(
  (
    {
      srcSet,
      src,
      className,
      size = 128,
      rounded = "circle",
      shadow,
      color = "primary",
      border,
      borderColor,
      userName,
      isOnline, // Not used
      isReply, // Not used
      avatarIcon,
      ...props
    },
    ref
  ) => {
    const { darkModeStatus } = useDarkMode();

    const INNER = (
      <img
        ref={ref}
        className={classNames(
          "avatar",
          {
            [`rounded${rounded !== "default" ? `-${rounded}` : ""}`]: rounded,
            "rounded-0": rounded === 0,
            [`shadow${shadow !== "default" ? `-${shadow}` : ""}`]: !!shadow,
            border: !!border,
            [`border-${border}`]: !!border,
            [`border-${borderColor}`]: borderColor,
          },
          `bg-l${darkModeStatus ? "o" : ""}25-${color}`,
          className
        )}
        srcSet={srcSet}
        src={src}
        alt="Avatar"
        width={size}
        height={size}
        onError={(e) => {
          e.target.onerror = null; // Prevent infinite loop if avatar also fails
          e.target.src = avatarIcon;
        }}
        {...props}
      />
    );

    return INNER;
  }
);

export default Avatar;
